import { api } from '@/lib/api'
import { buildReportParams } from '@/lib/api/reports'

/**
 * @param {{
 *   period?: string,
 *   customFrom?: string,
 *   customTo?: string,
 *   customerId?: number | null,
 *   stylistId?: number | null,
 *   search?: string,
 *   page?: number,
 *   perPage?: number,
 * }} [options]
 */
export async function fetchSaleHistory(options = {}) {
  const params = {
    ...buildReportParams({
      period: options.period,
      from: options.customFrom,
      to: options.customTo,
    }),
    customer_id: options.customerId ?? undefined,
    stylist_id: options.stylistId ?? undefined,
    search: options.search?.trim() || undefined,
    page: options.page ?? 1,
    per_page: options.perPage ?? 25,
  }

  const { data } = await api.get('/reports/sale-history', { params })
  return data.data
}
